export const sortByPriorityKey = (arr) => {
  const withPriority = arr.filter((item) => !!item.priority);
  const withoutPriority = arr.filter((item) => !item.priority);

  const sortedByPriority = withPriority.sort((a, b) => a.priority - b.priority);

  return [...sortedByPriority, ...withoutPriority];
};
